import { CheckCircle2 } from "lucide-react";
import { WaitlistForm } from "./WaitlistForm";

export function CTA(): JSX.Element {
  return (
    <section id="warteliste" aria-labelledby="cta-title" className="py-20 sm:py-24 lg:py-28">
      <div className="container-welope">
        <div className="bloom-on-scroll relative overflow-hidden rounded-2xl bg-gradient-to-br from-surface-container via-surface-container-low to-primary-fixed/40 p-md shadow-bloom-lg sm:p-lg lg:p-xl">
          {/* Editorial backdrop — single soft accent on the corner, no stacked blobs */}
          <div
            aria-hidden
            className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full bg-tertiary-fixed/35 blur-3xl"
          />

          <div className="relative grid grid-cols-1 gap-lg lg:grid-cols-12 lg:items-center lg:gap-xl">
            <div className="lg:col-span-7">
              <p className="section-eyebrow">Bald geht's los</p>
              <h2
                id="cta-title"
                className="mt-4 font-headline text-[36px] font-extrabold leading-[1.04] tracking-[-0.03em] text-primary sm:text-[52px] sm:leading-[1.02]"
              >
                Zeig deinem Liebling,
                <br />
                <span className="relative inline-block">
                  was online möglich ist.
                  <span
                    aria-hidden
                    className="absolute -bottom-1 left-0 right-0 h-2 rounded-full bg-secondary/70"
                  />
                </span>
              </h2>
              <p className="mt-6 max-w-xl font-body text-body-lg leading-[1.55] text-on-surface-variant">
                Welope wird gerade fertiggestellt. Trag dich ein, und wir schreiben dir, sobald
                du dir dein Profil anlegen kannst — kostenlos nutzbar.
              </p>

              <ul className="mt-7 grid grid-cols-1 gap-y-2.5 sm:grid-cols-2 sm:gap-x-6">
                {CTA_CHECKLIST.map((item) => (
                  <li
                    key={item}
                    className="flex items-center gap-2 font-body text-body-md text-on-surface"
                  >
                    <CheckCircle2 className="h-5 w-5 flex-none text-secondary" aria-hidden="true" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="relative lg:col-span-5">
              <WaitlistForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

/** Editorial copy tied to this CTA block — keep paired with the component. */
const CTA_CHECKLIST = [
  "Unbegrenzt viele Tier-Profile",
  "Volle Datenhoheit & DSGVO",
  "Mobile + Web in Echtzeit",
  "In Gemeinschaften & Gruppen",
] as const;
